import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as z from "zod";

export const getFulfillmentGroupsForOrder = {
  name: "getFulfillmentGroupsForOrder" as const,
  input: z
    .object({ orderId: z.string() })
    .or(z.object({ orderExternalId: z.string() })),
  output: z.object({ fulfillmentGroups: z.array(FulfillmentGroupDataSchema) }),
};
